<template>
    <div class="card a-accordion mb-3" :class="{ active: isActive }">
        <button
            type="button"
            @click="$emit('header-click')"
            class="a-accordion__header btn btn-accordion p-3"
        >
            <slot name="header" />

            <template v-if="$slots['expand-button']">
                <slot name="expand-button" />
            </template>
            <a-icon
                v-else-if="showChevron"
                class="a-accordion__chevron ml-0"
                icon="Chevron"
                style="min-width: 24px"
            />
        </button>

        <transition-slide>
            <div v-if="isActive">
                <div class="card-body p-3">
                    <slot name="body" />
                </div>
            </div>
        </transition-slide>
    </div>
</template>

<script>
export default {
    props: {
        isActive: {
            type: Boolean,
            default: false
        },

        showChevron: {
            type: Boolean,
            default: true
        }
    }
}
</script>
